import { Component, OnInit } from '@angular/core';

interface AdminActivity {
  timestamp: Date;
  user: string;
  action: string;
  status: 'Success' | 'Failed';
}

@Component({
  selector: 'app-superadmin-dashboard',
  templateUrl: './superadmin-dashboard.component.html',
  styleUrls: ['./superadmin-dashboard.component.scss']
})
export class SuperadminDashboardComponent implements OnInit {
    currentUser: any;

  
  // Overview Metrics
  totalUsers: number = 0;
  totalInstitutions: number = 0;
  activeSessions: number = 0;
  systemHealth: string = 'Unknown';

  // Quick Stats
  dailyLogins: number = 0;
  storageUsed: string = '0 GB';
  avgResponseTime: string = '0ms';

  // Recent Activities
  recentActivities: AdminActivity[] = [];

  // Debug Info
  currentTime: Date = new Date();

   public loading = false;


    public loaderConfig = {
    animationType: 'circleSwish',
    backdropBorderRadius: '2px',
    primaryColour: '#630f12',
    secondaryColour: '#630f12',
    tertiaryColour: '#ffcb05',
    backdropBackgroundColour: 'rgba(0, 0, 0, 0.5)',
    fullScreenBackdrop: true
  };

  constructor() { }

  ngOnInit(): void {
    this.loadUserData();
  this.loadDashboardData();

    // Initialize Overview Metrics
    this.totalUsers = 0;
    this.totalInstitutions = 0;
    this.activeSessions = 0;
    this.systemHealth = 'Operational';

    // Initialize Quick Stats
    this.dailyLogins = 589;
    this.storageUsed = '1.3 TB';
    this.avgResponseTime = '45ms';

    // Initialize Recent Activities (Mock Data)
    this.recentActivities = [
      { 
        timestamp: new Date(Date.now() - 60000 * 5), 
        user: 'Admin User', 
        action: 'Created new Institution "ABC"', 
        status: 'Success' 
      },
      { 
        timestamp: new Date(Date.now() - 60000 * 15), 
        user: 'System Bot', 
        action: 'Database Backup Completed', 
        status: 'Success' 
      },
      { 
        timestamp: new Date(Date.now() - 60000 * 25), 
        user: 'Regular User', 
        action: 'Failed to upload large file', 
        status: 'Failed' 
      },
      { 
        timestamp: new Date(Date.now() - 60000 * 45), 
        user: 'Admin User', 
        action: 'Updated system configuration', 
        status: 'Success' 
      },
    ];

    this.currentTime = new Date();
  }


  loadUserData(): void {
    const userStr = localStorage.getItem('sysadmin_user');
    this.currentUser = userStr ? JSON.parse(userStr) : { username: 'Registrar' };
  }

  loadDashboardData(): void {
    this.loading = true;
    //  api call here
    setTimeout(() => {
      this.loading = false;
    }, 1000);
  }
}